// NEW STYPEPARAMS METHOD
var SECONDARY_MEDIA_TRIGGER = {
    OFF: 'OFF',
    HOVER: 'HOVER',
};
export default SECONDARY_MEDIA_TRIGGER;
//# sourceMappingURL=behaviourParams_item_secondaryMedia_trigger.js.map